/**
 * 意见反馈 - 枚举定义
 *
 * @description 定义反馈类型和状态枚举
 * @module types/feedback/enums
 * @author AI Assistant
 * @version 1.0.0
 * @since 2026-01-21
 *
 * 对应后端文件：
 * - Model: backend/app/Modules/Feedback/Models/Feedback.php
 */

/**
 * 反馈类型枚举
 *
 * 对应后端常量：
 * - TYPE_BUG = 'bug'
 * - TYPE_SUGGESTION = 'suggestion'
 * - TYPE_FEATURE = 'feature'
 * - TYPE_OTHER = 'other'
 */
export enum FeedbackType {
  /** 问题反馈 */
  Bug = 'bug',
  /** 建议 */
  Suggestion = 'suggestion',
  /** 功能需求 */
  Feature = 'feature',
  /** 其他 */
  Other = 'other',
}

/**
 * 反馈状态枚举
 *
 * 对应后端常量：
 * - STATUS_PENDING = 'pending'
 * - STATUS_PROCESSING = 'processing'
 * - STATUS_REPLIED = 'replied'
 * - STATUS_RESOLVED = 'resolved'
 * - STATUS_CLOSED = 'closed'
 */
export enum FeedbackStatus {
  /** 待处理 */
  Pending = 'pending',
  /** 处理中 */
  Processing = 'processing',
  /** 已回复（等待用户确认或追问） */
  Replied = 'replied',
  /** 已解决 */
  Resolved = 'resolved',
  /** 已关闭 */
  Closed = 'closed',
}

/**
 * 反馈业务来源类型枚举
 *
 * 对应后端常量：
 * - BUSINESS_TYPE_WAGE_MONTH = 'wage_month'
 * - BUSINESS_TYPE_WAGE_RECORD = 'wage_record'
 */
export enum FeedbackBusinessType {
  /** 员工某个月份的工资异议 */
  WageMonth = 'wage_month',
  /** 单条工资记录异议 */
  WageRecord = 'wage_record',
}
